import { useEffect, useState } from "react";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import SectionClientSlider from "./SectionClientSlider";
import SectionCounter from "./SectionCounter";
import SectionJoin from "./SectionJoin";
import SectionTestimonial from "./SectionTestimonial";
import SectionWhy from "./SectionWhy";
import SectionWho from "./SectionWho";
import topbarimg1 from "../../assets/images/t1.png";
import topbarimg2 from "../../assets/images/t2.png";
import topbarimg3 from "../../assets/images/b3.png";
import topbarimg4 from "../../assets/images/b4.png";
import logoSmall from "../../assets/images/logo-small.png";
import { Bounce, Fade, Slide } from "react-awesome-reveal";
import SectionJoinUsNow from "./SectionJoinUsNow";
// import { Link } from "react-router-dom";
const Home = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const nameArray = ["M", "y", "G", "r", "a", "d", "e", "C", "a", "r", "d"];

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4000);
    return () => clearTimeout(timer);
  });
  return (
    <>
      <div className="home-page">
        <div className="top-section">
          <div className="top-section-content">
            <div className="w3-container">
              <div className="w3-row">
                <div className="w3-half">
                  <div className="text-zone">
                    <img
                      src={logoSmall}
                      alt="my-grade-card"
                      className="top-section-logo"
                    />
                    <h1>
                      {" "}
                      <AnimatedLetters
                        letterClass={letterClass}
                        strArray={nameArray}
                        idx={22}
                      />
                    </h1>
                    <div className="content">
                      <div className="content__container">
                        <p className="content__container__text">For</p>

                        <ul className="content__container__list">
                          <li className="content__container__list__item">
                            Schools !
                          </li>
                          <li className="content__container__list__item">
                            Teachers !
                          </li>
                          <li className="content__container__list__item">
                            Parents !
                          </li>
                          <li className="content__container__list__item">
                            Students !
                          </li>
                        </ul>
                      </div>
                    </div>
                    <h4>Running your School Smartly</h4>
                    <p style={{ "text-align": "justify" }}>
                      With MyGradeCard you'll be able to Save time and energy,
                      stop financial leakages, preserve records, track payments,
                      Effectively and efficiently compile error-free results,
                      Improve Student Learning, Enhance Parent Engagement and
                      boost staff productivity.
                    </p>

                    <button className="btn-solid">Get Started for Free</button>
                    <a href="https://accounts.mygradecard.online/">
                      <button className="btn-transparent">Login</button>
                    </a>
                  </div>
                </div>
                <div className="w3-half w3-hide-small" align="center">
                  <div className="w3-container topbarimgDiv">
                    <div className="w3-row">
                      <div className="w3-col topbarimg">
                        <Slide>
                          <img src={topbarimg1} alt="" />
                        </Slide>
                      </div>
                      <div className="w3-col topbarimg">
                        <Bounce>
                          <img src={topbarimg2} alt="" />
                        </Bounce>
                      </div>
                    </div>
                    <div className="w3-row ">
                      <div className="w3-col topbarimg">
                        <Fade>
                          <img src={topbarimg3} alt="" />
                        </Fade>
                      </div>
                      <div className="w3-col topbarimg">
                        <Slide direction="right">
                          <img src={topbarimg4} alt="" />
                        </Slide>
                      </div>
                    </div>
                  </div>
                  {/* <img src={topbarimg} /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <SectionWho />
        <SectionWhy />
        <SectionCounter />
        <SectionTestimonial />
        <SectionJoin />
        <SectionJoinUsNow />
        <SectionClientSlider />
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default Home;
